<template>
  <div
    class="exhibitionSale"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">Regong Art Exhibition and Sales</span>
        </div>
      </div>
    </div>
    <!-- PC -->
    <div class="saleTop hidden-xs-only">
      <div class="section">
        <div class="saleTopList">
          <div
            class="item"
            v-for="(item, index) in saleTopList"
            :key="index"
            @click="chooseCategory(index, item.id)"
          >
            <img class="img" :src="item.imgSrc" alt="" />
            <span class="title eng_title">{{ item.eng_title }}</span>
            <div :class="isClick == item.id ? 'isClick' : ''"></div>
          </div>
        </div>
        <!-- 全部寺院 -->
        <div class="planting" v-if="!show">
          <div
            class="item eng_item"
            v-for="(item, index) in paintingList"
            :key="index"
            :class="isActive == index ? 'isActive' : ''"
            @click="goPainting(index, item.id)"
          >
            <div class="itemDuty">{{ item.englishName }}</div>
          </div>
        </div>
        <!-- 部分寺院-->
        <div class="planting" v-if="show">
          <div
            class="item eng_item"
            v-for="(item, index) in paintingLeftList"
            :key="index"
            :class="isActive == index ? 'isActive' : ''"
            @click="goPainting(index, item.id)"
          >
            <div class="itemDuty">{{ item.englishName }}</div>
          </div>
        </div>
        <div class="open">
          <div class="openButton" v-if="show" @click="openButton">
            <span>Spread out</span>
            <span class="triangle"></span>
          </div>
          <div class="closeButton" v-if="!show" @click="closeOpen">
            <span>Put it away</span>
            <span class="triangle"></span>
          </div>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <!-- PC -->
    <div class="saleContent hidden-xs-only">
      <div class="section">
        <div class="waterfallBox">
          <water-fall-sale
            :data="cardList"
            v-if="cardList.length !== 0"
          ></water-fall-sale>
          <div class="noMessage" v-if="noMessage">暂无数据</div>
        </div>
      </div>
      <div
        class="loading"
        v-loading="loading"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
      ></div>
    </div>
    <!-- mobile -->
    <div class="mobileContent hidden-sm-and-up">
      <div class="mobileContentLeft">
        <div
          class="item"
          v-for="(item, index) in paintingList"
          :key="index"
          :class="isActive == index ? 'isActive' : ''"
          @click="goLeftDetail(index, item.id)"
        >
          <div class="itemName eng_itemName">{{ item.englishName }}</div>
          <div class="itemDuty">{{ item.englishDuty }}</div>
        </div>
      </div>
      <div class="mobileContentRight">
        <div class="mobileContentRightTop">
          <div
            class="item eng_item"
            v-for="(item, index) in saleTopList"
            @click="goTopDetail(index, item.id)"
            :class="isActiveColor == item.id ? 'isActiveColor' : ''"
            :key="index"
          >
            <span class="title">{{ item.eng_title }}</span>
          </div>
        </div>
        <div class="mobileContentRightbottom">
          <div
            class="waterfallBox"
            @click="goDetail(item.id)"
            v-for="(item, index) in cardListMobile"
            :key="index"
          >
            <img
              class="imageOne"
              v-if="item.watermark.length>0"
              :src="url + item.watermark[0].thinUrl"
              alt="加载错误"
            />
            <img v-else src="" alt="" />
            <div class="item-body">
              <div class="item-desc">{{ item.title }}</div>
              <div class="item-footer">
                <div class="footer-left">
                  <img
                    class="image"
                    v-if="item.authorPicture"
                    :src="url + item.authorPicture.thinUrl"
                    alt="加载错误"
                  />
                  <span class="noneImage" v-else></span>
                  <div class="name">{{item.englishName }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="noMessage" v-if="noMessage">none</div>
          <div
            class="loading"
            v-loading="loading"
            element-loading-text="数据加载中"
            element-loading-spinner="el-icon-loading"
          ></div>
        </div>
      </div>
    </div>
    <div class="contact">
      <div class="made" v-if="isActive!==0" @click="goExhibitionMade()">
        <img src="../../assets/exhibitionsale/user.png" alt="" />
        <div>Customized Work</div>
      </div>
      <el-popover v-if="isActive!==0" placement="left" width="240" trigger="hover">
        <div class="tel">Contact Number：{{contactPhone}}</div>
        <div class="tel">Email：{{email}}</div>
        <div class="mobile" slot="reference">
          <div class="message">
            <img src="../../assets/exhibitionsale/phone.png" alt="" />
            <div>Contact art studio</div>
          </div>
        </div>
      </el-popover>
      <el-popover v-if="isActive==0" placement="left" width="240" trigger="hover">
        <div class="tel">Contact Number：{{contactPhone}}</div>
        <div class="tel">Email：{{email}}</div>
        <div class="mobile" slot="reference">
          <div class="message">
            <img src="../../assets/dataType/message.png" alt="" />
            <div>Regong IP Authorization</div>
          </div>
        </div>
      </el-popover>
    </div>
    <img
      class="hidden-sm-and-up cloudright wow animate__animated animate__fadeInRight"
      src="../../assets/newImage/index/could_right.png"
      alt=""
    />
  </div>
  <div class="exhibitionSale" v-else-if="this.language == 'en'">
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">རེབ་གོང་སྒྱུ་རྩལ་ཐོན་རྫས་འགྲེམས་འཚོང་</span>
        </div>
      </div>
    </div>
    <!-- PC -->
    <div class="saleTop hidden-xs-only">
      <div class="section">
        <div class="saleTopList">
          <div
            class="item"
            v-for="(item, index) in saleTopList"
            :key="index"
            @click="chooseCategory(index, item.id)"
          >
            <img class="img" :src="item.imgSrc" alt />
            <span class="title">{{ item.za_title }}</span>
            <div :class="isClick == item.id ? 'isClick' : ''"></div>
          </div>
        </div>
        <!-- 全部寺院 -->
        <div class="planting" v-if="!show">
          <div
            class="item"
            v-for="(item, index) in paintingList"
            :key="index"
            :class="isActive == index ? 'isActive' : ''"
            @click="goPainting(index, item.id)"
          >
            <div class="itemDuty">{{ item.zangName }}</div>
          </div>
        </div>
        <!-- 部分寺院-->
        <div class="planting" v-if="show">
          <div
            class="item"
            v-for="(item, index) in paintingLeftList"
            :key="index"
            :class="isActive == index ? 'isActive' : ''"
            @click="goPainting(index, item.id)"
          >
            <div class="itemName">{{ item.zangName }}</div>
          </div>
        </div>
        <div class="open">
          <div class="openButton" v-if="show" @click="openButton">
            <span>བཀྲམ་པ་</span>
            <span class="triangle"></span>
          </div>
          <div class="closeButton" v-if="!show" @click="closeOpen">
            <span>བསྡུ་ཉར་</span>
            <span class="triangle"></span>
          </div>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt
      />
    </div>
    <!-- PC -->
    <div class="saleContent hidden-xs-only">
      <div class="section">
        <div class="waterfallBox">
          <water-fall-sale
            :data="cardList"
            v-if="cardList.length !== 0"
          ></water-fall-sale>
          <div class="noMessage" v-if="noMessage">གནས་སྐབས་གཞི་གྲངས་མེད་པ་</div>
        </div>
      </div>
      <div
        class="loading"
        v-loading="loading"
        element-loading-text="གཞི་གྲངས་སྣོན་འཇུག་ཁྲོད་"
        element-loading-spinner="el-icon-loading"
      ></div>
    </div>
    <!-- mobile -->
    <div class="mobileContent hidden-sm-and-up">
      <div class="mobileContentLeft">
        <div
          class="item za_item"
          v-for="(item, index) in paintingList"
          :key="index"
          :class="isActive == index ? 'isActive' : ''"
          @click="goLeftDetail(index, item.id)"
        >
          <div class="itemName">{{ item.zangName }}</div>
          <div class="itemDuty">{{ item.zangDuty }}</div>
        </div>
      </div>
      <div class="mobileContentRight">
        <div class="mobileContentRightTop">
          <div
            class="za_item"
            v-for="(item, index) in saleTopList"
            @click="goTopDetail(index, item.id)"
            :class="isActiveColor == item.id ? 'isActiveColor' : ''"
            :key="index"
          >
            <span class="title">{{ item.za_title }}</span>
          </div>
        </div>
        <div class="mobileContentRightbottom">
          <div
            class="waterfallBox"
            @click="goDetail(item.id)"
            v-for="(item, index) in cardListMobile"
            :key="index"
          >
            <img
              class="imageOne"
              v-if="item.watermark.length>0"
              :src="url + item.watermark[0].thinUrl"
              alt="ཁུར་སྣོན་ནོར་འཁྲུལ།"
            />
            <img v-else src alt />
            <div class="item-body">
              <div class="item-desc">{{ item.title }}</div>
              <div class="item-footer">
                <div class="footer-left">
                  <img
                    class="image"
                    v-if="item.authorPicture"
                    :src="url + item.authorPicture.thinUrl"
                    alt="ཁུར་སྣོན་ནོར་འཁྲུལ།"
                  />
                  <span class="noneImage" v-else></span>
                  <div class="name">{{ item.zangName }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="noMessage" v-if="noMessage">གནས་སྐབས་གཞི་གྲངས་མེད་པ་</div>
          <div
            class="loading"
            v-loading="loading"
            element-loading-text="གཞི་གྲངས་སྣོན་འཇུག་ཁྲོད་"
            element-loading-spinner="el-icon-loading"
          ></div>
        </div>
      </div>
    </div>
    <div class="contact">
      <div class="made" v-if="isActive!==0" @click="goExhibitionMade()">
        <img src="../../assets/exhibitionsale/user.png" alt />
        <div>གཏན་ཁེལ།</div>
      </div>
      <el-popover v-if="isActive!==0" placement="left" width="240" trigger="hover">
        <div class="tel">འབྲེལ་གཏུགས་ཨང་གྲངས།：{{contactPhone}}</div>
        <div class="tel">སྦྲགས་ཡིག：{{email}}</div>
        <div class="mobile" slot="reference">
          <div class="message">
            <img src="../../assets/exhibitionsale/phone.png" alt="" />
            <div>འབྲེལ་གཏུག་</div>
          </div>
        </div>
      </el-popover>
      <el-popover v-if="isActive==0" placement="left" width="240" trigger="hover">
        <div class="tel">འབྲེལ་གཏུགས་ཨང་གྲངས།：{{contactPhone}}</div>
        <div class="tel">སྦྲགས་ཡིག：{{email}}</div>
        <div class="mobile" slot="reference">
          <div class="message">
            <img src="../../assets/dataType/message.png" alt="" />
            <div>རི་གོང་IPདབང་ཆ་བསྐུར་བ།</div>
          </div>
        </div>
      </el-popover>
    </div>
    <img
      class="hidden-sm-and-up cloudright wow animate__animated animate__fadeInRight"
      src="../../assets/newImage/index/could_right.png"
      alt
    />
  </div>
  <div class="exhibitionSale" v-else>
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">热贡作品展销</span>
        </div>
      </div>
    </div>
    <!-- PC -->
    <div class="saleTop hidden-xs-only">
      <div class="section">
        <div class="saleTopList">
          <div
            class="item"
            v-for="(item, index) in saleTopList"
            :key="index"
            @click="chooseCategory(index, item.id)"
          >
            <img class="img" :src="item.imgSrc" alt="" />
            <span class="title">{{ item.title }}</span>
            <div :class="isClick == item.id ? 'isClick' : ''"></div>
          </div>
        </div>
        <!-- 全部寺院 -->
        <div class="planting" v-if="!show">
          <div
            class="item"
            v-for="(item, index) in paintingList"
            :key="index"
            :class="isActive == index ? 'isActive' : ''"
            @click="goPainting(index, item.id)"
          >
            <div class="itemName">{{ item.chineseName }}</div>
          </div>
        </div>
        <!-- 部分寺院-->
        <div class="planting" v-if="show">
          <div
            class="item"
            v-for="(item, index) in paintingLeftList"
            :key="index"
            :class="isActive == index ? 'isActive' : ''"
            @click="goPainting(index, item.id)"
          >
            <div class="itemName">{{ item.chineseName }}</div>
          </div>
        </div>
        <div class="open">
          <div class="openButton" v-if="show" @click="openButton">
            <span>展开</span>
            <span class="triangle"></span>
          </div>
          <div class="closeButton" v-if="!show" @click="closeOpen">
            <span>收起</span>
            <span class="triangle"></span>
          </div>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <!-- PC -->
    <div class="saleContent hidden-xs-only">
      <div class="section">
        <div class="waterfallBox">
          <water-fall-sale
            :data="cardList"
            v-if="cardList.length !== 0"
          ></water-fall-sale>
          <div class="noMessage" v-if="noMessage">暂无数据</div>
        </div>
      </div>
      <div
        class="loading"
        v-loading="loading"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
      ></div>
    </div>
    <!-- mobile -->
    <div class="mobileContent hidden-sm-and-up">
      <div class="mobileContentLeft">
        <div
          class="item"
          v-for="(item, index) in paintingList"
          :key="index"
          :class="isActive == index ? 'isActive' : ''"
          @click="goLeftDetail(index, item.id)"
        >
          <div class="itemName">{{ item.chineseName }}</div>
          <div class="itemDuty">{{ item.chineseDuty }}</div>
        </div>
      </div>
      <div class="mobileContentRight">
        <div class="mobileContentRightTop">
          <div
            class="item"
            v-for="(item, index) in saleTopList"
            @click="goTopDetail(index, item.id)"
            :class="isActiveColor == item.id ? 'isActiveColor' : ''"
            :key="index"
          >
            <span class="title">{{ item.title }}</span>
          </div>
        </div>
        <div class="mobileContentRightbottom">
          <div
            class="waterfallBox"
            @click="goDetail(item.id)"
            v-for="(item, index) in cardListMobile"
            :key="index"
          >
            <img
              class="imageOne"
              v-if="item.watermark.length>0"
              :src="url + item.watermark[0].thinUrl"
              alt="加载错误"
            />
            <img v-else src="" alt="" />
            <div class="item-body">
              <div class="item-desc">{{ item.title }}</div>
              <div class="item-footer">
                <div class="footer-left">
                  <img
                    class="image"
                    v-if="item.authorPicture"
                    :src="url + item.authorPicture.thinUrl"
                    alt="加载错误"
                  />
                  <span class="noneImage" v-else></span>
                  <div class="name">{{ item.chineseName }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="noMessage" v-if="noMessage">暂无数据</div>
          <div
            class="loading"
            v-loading="loading"
            element-loading-text="数据加载中"
            element-loading-spinner="el-icon-loading"
          ></div>
        </div>
      </div>
    </div>
    <div class="contact">
      <div class="made" v-if="isActive!==0" @click="goExhibitionMade()">
        <img src="../../assets/exhibitionsale/user.png" alt="" />
        <div>作品定制</div>
      </div>
      <el-popover v-if="isActive!==0" placement="left" width="240" trigger="hover">
        <div class="tel">联系电话：{{contactPhone}}</div>
        <div class="tel">邮件：{{email}}</div>
        <div class="mobile" slot="reference">
          <div class="message">
            <img src="../../assets/exhibitionsale/phone.png" alt="" />
            <div>联系画院</div>
          </div>
        </div>
      </el-popover>
      <el-popover v-if="isActive==0" placement="left" width="240" trigger="hover">
        <div class="tel">联系电话：{{contactPhone}}</div>
        <div class="tel">邮件：{{email}}</div>
        <div class="mobile" slot="reference">
          <div class="message">
            <img src="../../assets/dataType/message.png" alt="" />
            <div>热贡IP使用咨询</div>
          </div>
        </div>
      </el-popover>
    </div>
    <img
      class="hidden-sm-and-up cloudright wow animate__animated animate__fadeInRight"
      src="../../assets/newImage/index/could_right.png"
      alt=""
    />
  </div>
</template>
<script>
import waterFallSale from "../../components/waterFallSale.vue";
import PicTop from "../../components/picsTop.vue";
import { templePage, productPage ,templeGet} from "../../api/management.js";
import { throttle } from 'lodash'
export default {
  components: {
    waterFallSale,
    PicTop,
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  data() {
    return {
      language: this.$store.state.language,
      url: process.env.VUE_APP_WEB_URL,
      total: null,
      isActive: 0,
      isClick: 0,
      isActiveColor: 0,
      //画院
      queryInfo: {
        current: 1,
        productCategory:'',
        pageSize: 10000,
      },
      //作品PC
      Info: {
        current: 1,
        pageSize: 9,
        category: "",
        templeId: "",
        saleSeen: true,
      },
      //作品Mobile
      mobileTotal: null,
      mobileInfo: {
        current: 1,
        pageSize: 6,
        category: "",
        templeId: "",
        saleSeen: true,
      },
      //分类
      saleTopList: [
        {
          imgSrc: require("../../assets/exhibitionImage/One.jpg"),
          title: "唐\xa0\xa0\xa0卡",
          za_title: "ཐང་ག",
          id: 1,
          eng_title: "Thangka",
        },
        {
          imgSrc: require("../../assets/exhibitionImage/Two.jpg"),
          title: "泥\xa0\xa0\xa0塑",
          za_title: "འཇིམ་བཟོ། ",
          id: 2,
          eng_title: "Clay sculpture",
        },
        {
          imgSrc: require("../../assets/exhibitionImage/Three.jpg"),
          title: "壁\xa0\xa0\xa0画",
          za_title: "ལྡེབས་རིས།",
          id: 3,
          eng_title: "Mural",
        },
        {
          imgSrc: require("../../assets/exhibitionImage/Four.jpg"),
          title: "堆\xa0\xa0\xa0绣",
          za_title: "དྲས་དྲུབ།",
          id: 4,
          eng_title: "Pile embroidery",
        },
        {
          imgSrc: require("../../assets/exhibitionImage/Five.jpg"),
          title: "彩\xa0\xa0\xa0绘",
          za_title: "ཚོན་རིས།",
          id: 5,
          eng_title: "Paintings",
        },
        {
          imgSrc: require("../../assets/exhibitionImage/all.png"),
          title: "其\xa0\xa0\xa0他",
          za_title: "གཞན་དག",
          id: 6,
          eng_title: "Other",
        },
      ],
      paintingList: [
        {
          chineseName: "全部",
          zangName: "ཡོངས་རྫོགས།",
          id: "",
          englishName: "All",
        },
      ], //画院列表
      cardList: [], //作品列表
      cardListMobile: [],
      paintingLeftList: [],
      show: true,
      loading: false, 
      noMessage: false,
      isMobile:false,

      isLoading:false,
      contactPhone:'18997193666',
      email:'regong_art_db@163.com'
    };
  },
  methods: {
    getPCorMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.isMobile = true
        this.getMobileProductPage();
        window.addEventListener("scroll", this.Scrollbottom, true);
      } else {
        this.isMobile = false
        this.getProductPage();
        window.addEventListener("scroll", this.PCscrollBottom, true);
      }
    },
    goDetail(id) {
      this.$router.push({ path: "/exhibitionSearchDetail", query: { id: id } });
    },
    //画院列表
    async getTemplePage() {
      const res = await templePage(this.queryInfo);
      if (res.code == 1) {
        this.paintingList = this.paintingList.concat(res.data.records);
        // let list = this.paintingList.concat(res.data.records);
        if(res.data.records.length>=6) {
          this.paintingLeftList = this.paintingList.slice(0, 6);
        } else {
          this.paintingLeftList = this.paintingList
        }
      }
    },
    //作品列表
    async getProductPage() {
      this.loading = true;
      const res = await productPage(this.Info);
      if (res.code == 1) {
        this.loading = false
        this.isLoading = false
        this.cardList = this.cardList.concat(res.data.records);
        this.total = res.data.total;
        if (res.data.total <= 0) {
          this.noMessage = true;
        }
      }
    },
    //分类
    chooseCategory(index, id) {
      this.noMessage = false;
      this.loading = true;
      this.isClick = id;
      this.Info.category = id;
      this.cardList = [];
      this.Info.current = 1
      this.isActive = 0
      setTimeout(() => {
        this.getProductPage();
      }, 300);
      this.queryInfo.productCategory = id
      this.paintingList = [
        {
          chineseName: "全部",
          zangName: "ཡོངས་རྫོགས།",
          id: "",
          englishName: "All",
        },
      ],
      this.paintingLeftList = []
      setTimeout(() => {
        this.getTemplePage()
      }, 300);
      

    },
    //画院
    goPainting(index, id) {
      this.noMessage = false;
      this.loading = true;
      this.isActive = index;
      this.Info.templeId = id;
      this.cardList = [];
      this.Info.current = 1
      setTimeout(() => {
        this.getProductPage();
      }, 300);
      // 获取画院详情
      if(id&&id>0) {
        this.getTempleDetail(id)
      } else {
        this.contactPhone = '18997193666'
        this.email = 'regong_art_db@163.com'
      }
    },
    async getTempleDetail(id) {
      const res = await templeGet(id);
      if (res.code == 1) {
        // console.log(res);
        this.contactPhone = res.data.contact
        if(res.data.contact) {
          this.contactPhone = res.data.contact
        } else {
          this.contactPhone = '18997193666'
        }
        if(res.data.email) {
          this.email = res.data.email
        } else {
          this.email = 'regong_art_db@163.com'
        }
      }
    },
    //手机
    goLeftDetail(index, id) {
      this.noMessage = false;
      this.isActive = index;
      this.mobileInfo.templeId = id;
      this.mobileInfo.current = 1;
      this.loading = true
      this.cardListMobile = [];
      setTimeout(() => {
        this.getMobileProductPage();
      }, 300);
      // 获取画院详情
      if(id&&id>0) {
        this.getTempleDetail(id)
      } else {
        this.contactPhone = '18997193666'
        this.email = 'regong_art_db@163.com'
      }
    },
    goTopDetail(index, id) {
      this.noMessage = false;
      this.isActiveColor = id;
      this.mobileInfo.category = id;
      this.mobileInfo.current = 1;
      this.loading = true
      this.cardListMobile = [];
      this.isActive = 0
      setTimeout(() => {
        this.getMobileProductPage();
      }, 300);
      this.queryInfo.productCategory = id
      this.paintingList = [
        {
          chineseName: "全部",
          zangName: "ཡོངས་རྫོགས།",
          id: "",
          englishName: "All",
        },
      ],
      this.getTemplePage()
      
    },
    async getMobileProductPage() {
      this.loading = true;
      const res = await productPage(this.mobileInfo);
      if(res.code==1) {
        this.isLoading = false
        this.loading = false
        this.cardListMobile = this.cardListMobile.concat(res.data.records);
        this.mobileTotal = res.data.total;
      }
      if (res.data.total <= 0) {
        this.noMessage = true;
      }
    },
    PCscrollBottom:throttle(function(event) {
      // 变量scrollTop为当前页面的滚动条纵坐标位置
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 变量 windowHeight 是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 变量 scrollHeight 是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // 到底的条件
      if (scrollTop + windowHeight == scrollHeight) {
        if(this.isLoading) {
          if (this.Info.current * 9 >= this.total) {
            this.isLoading = false
            return this.$message("数据加载完毕");
          }
          this.loading = true;
          this.Info.current++;
          this.getProductPage();
        }
      } else {
        this.isLoading = true
      }
    },1000),
    Scrollbottom:throttle(function(event) {
      let scrollTop = document.getElementsByClassName('mobileContentRightbottom')[0].scrollTop;
      let clientHeight = document.getElementsByClassName('mobileContentRightbottom')[0].clientHeight;
      let scrollHeight = document.getElementsByClassName('mobileContentRightbottom')[0].scrollHeight;
      if (scrollTop + clientHeight + 100 >= scrollHeight) {
        if(this.isLoading) {
          if (this.mobileInfo.current * 6 >= this.mobileTotal) {
            this.isLoading = false
            return this.$message("数据加载完毕");
          }
          this.loading = true;
          this.mobileInfo.current += 1;
          this.getMobileProductPage();
        }
      } else {
        this.isLoading = true
      }
    },2000),
    //作品定制
    goExhibitionMade() {
      let phone = this.contactPhone
      let email = this.email
      let templeId = ''
      if(this.isMobile) {
        templeId = this.mobileInfo.templeId
      } else {
        templeId = this.Info.templeId
      }
      this.$router.push({path: "/exhibitionMade", query: {templeId: templeId,phone: phone,email: email}});
    },
    openButton() {
      this.show = false;
    },
    closeOpen() {
      this.show = true;
    },
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
  },
  mounted() {
    new this.$wow.WOW().init();
  },
  created() {
    this.getPCorMobile();
    this.getTemplePage();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.PCscrollBottom, true);
    window.removeEventListener("scroll", this.Scrollbottom, true);
  },
};
</script>
<style lang="scss">
.exhibitionSale {
  position: relative;
  background: url("../../assets/newImage/index/could_right.png") no-repeat right
    bottom;
  background-position: 100% 100%;
  background-size: 7%;
  .exhibitionTop {
    position: relative;
    border-bottom: 1px solid #f4f5f6;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
    }
  }
  .saleTop {
    border-bottom: 1px solid #f4f5f6;
    padding: 50px 0;
    position: relative;
    .section {
      .saleTopList {
        display: flex;
        justify-content: space-between;
        width: 100%;
        .item {
          cursor: pointer;
          height: 110px;
          //间隙控制
          // margin-right: 4px;
          position: relative;
          .title {
            white-space: nowrap;
            position: absolute;
            color: #fff;
            font-family: "fangzang";
            font-size: 20px;
            z-index: 99;
            right: 10px;
           bottom: 2px;
          }
          .eng_title {
            font-size: 17px;
            bottom: 4px;
            font-family: "Times New Roman", Times, serif;
          }
          .img {
            height: 110px;
          }
        }
        .isClick {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0.7;
          background-color: #304462;
        }
      }
      .planting {
        padding: 50px 0;
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        &::after {
          content: "";
          flex: auto;
        }
        .item {
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          width: 196px;
          //用margin控制一行或多行展示时（文字不会产生偏移）
          margin-right: 4px;
          height: 90px;
          position: relative;
          font-family: "fangzang";
          .itemName {
            font-size: 20px;
          }
          .itemDuty {
            font-size: 18px;
          }
        }
        .eng_item {
          font-family: "Times New Roman", Times, serif;
        }
        .isActive {
          background-color: #304462;
          color: #fff;
        }
      }
      .open {
        display: flex;
        justify-content: center;
        align-items: center;
        .openButton,
        .closeButton {
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
          background-color: #304462;
          padding: 8px 38px 8px 20px;
          .triangle {
            width: 0px;
            height: 0px;
            margin-left: 10px;
            border-bottom: 8px solid #fff;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
          }
        }
        .openButton {
          .triangle {
            transform: rotate(180deg);
          }
        }
      }
    }
    .cloudLeft {
      position: absolute;
      top: -50px;
      left: 0;
      z-index: 1;
      width: 125px;
      height: 95px;
    }
  }
  .cloudright {
    position: absolute;
    right: 0;
    bottom: 0;
  }
  .contact {
    z-index: 99;
    color: #fff;
    position: fixed;
    right: 2%;
    bottom: 20%;
    .made,
    .mobile {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      text-align: center;
      width: 110px;
      height: 110px;
      border-radius: 100%;
      background-color: #99131a;
      font-size: 12px;
      margin-bottom: 20px;
      box-shadow: 0 0 10px #99131a;
      border: none;
      img {
        width: 32px;
        margin-bottom: 6px;
      }
    }
  }
  .show {
    display: block;
  }
  .none {
    display: none;
  }
  .saleContent {
    min-height: 30px;
    .section {
      .waterfallBox {
        .noMessage {
          margin: 20px 0;
          letter-spacing: 4px;
          font-weight: bold;
          font-size: 24px;
          text-align: center;
        }
      }
    }
    .loading {
      margin-bottom: 20px;
      .el-loading-mask {
        .el-loading-spinner {
          .el-icon-loading {
            color: #ef3731;
          }
          .el-loading-text {
            color: #ef3731;
          }
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .exhibitionSale {
    background: none;
    position: relative;
    .exhibitionTop {
      background: url("../../assets/newImage/index/could_left.png") no-repeat
        top left;
      background-position: 0 50%;
      background-size: 15%;
      .section {
        padding: 0.6rem 0.2rem;
        font-size: 0.3rem;
        .section_left {
          left: 0.2rem;
        }
      }
    }
    .mobileContent {
      display: flex;
      margin-top: 0.5rem;
      height: 10rem;
      .mobileContentLeft {
        background-color: #e9e9e9;
        width: 22%;
        height: 100%;
        overflow-y: auto;
        .item {
          height: 1rem;
          display: flex;
          text-align: center;
          flex-direction: column;
          justify-content: center;
          .itemName {
            font-size: 0.3rem;
            font-family: "fangzang";
            overflow:hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;
          }
          .eng_itemName {
            font-family: "Times New Roman", Times, serif;
            font-size: 0.26rem;
          }
          .itemDuty {
            font-size: 0.2rem;
            overflow:hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow:ellipsis;
          }
        }
        .za_item {
          margin-bottom: 0.24rem;
          .itemName {
            font-size: 0.22rem;
            text-align: center;
            overflow:hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;
          }
          .itemDuty {
            font-size: 0.2rem;
            overflow:hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow:ellipsis;
          }
        }
        .isActive {
          background-color: #99131a;
          color: #fff;
        }
      }
      .mobileContentLeft::-webkit-scrollbar {
        display: none;
      }
      .mobileContentLeft{
        scrollbar-width: none; 
        -ms-overflow-style: none; 
        overflow-x: hidden;
        overflow-y: auto;
      }
      .mobileContentRight {
        padding: 0 0.2rem;
        width: 78%;
        height: 100%;
        .mobileContentRightTop {
          display: flex;
          height: .5rem;
          justify-content: space-between;
          .isActiveColor {
            color: #99131a;
          }
          .item {
            .title {
              font-size: 0.33rem;
              font-family: "fangzang";
            }
          }
          .za_item {
            margin-left: 0.02rem;
            .title {
              font-size: 0.3rem;
              font-family: "fangzang";
            }
          }
          .eng_item {
            white-space: normal;
            text-align: center;
            margin-right: 0.08rem;
            line-height: 0.22rem;
            height: 0.3rem;
            .title {
              font-size: 0.23rem;
              font-family: "Times New Roman", Times, serif;
            }
          }
        }
        .mobileContentRightbottom {
          overflow: hidden;
          scrollbar-width: none; /* Firefox */
          -ms-overflow-style: none; /* IE 10+ */
          overflow-y: scroll;
          height: 9.4rem;
          margin: 0.1rem 0 0 0;
          display: flex;
          flex-wrap: wrap;
          .waterfallBox {
            .item-body {
              margin-top: 0.15rem;
              .item-footer {
                .footer-left {
                  display: flex;
                  align-items: center;
                  width: 100%;
                  .image {
                    border-radius: 0.6rem;
                    width: 0.6rem !important;
                    height: 0.6rem !important;
                    margin-right: 0.1rem;
                  }
                  .noneImage {
                    margin-right: 0.1rem !important;
                    border-radius: 0.6rem;
                    width: 0.6rem !important;
                    height: 0.6rem !important;
                    border: 1px solid #e9e9e9;
                  }
                  .name {
                    width: calc(100% - .7rem);
                    font-size: 0.25rem;
                    text-overflow: ellipsis;
                    overflow: hidden; /* 文本超出的部分隐藏 */
                    display: -webkit-box;/* 弹性伸缩盒模型显示 */
                    -webkit-line-clamp: 1;/* 限制在一个块元素中显示文本的行数 */
                    -webkit-box-orient: vertical;/* 设置伸缩盒子对象的子元素的排列方式 */
                  }
                }
              }
            }
            width: 2.5rem;
            margin-right: 0.2rem;
            margin-bottom: 0.4rem;
            .imageOne {
              width: 2.5rem;
              height: 3rem;
            }
            .waterfallBox:nth-child(2n) {
              margin-right: 0;
            }
          }
          .noMessage {
            width: 100%;
            height: 100%;
            font-weight: bold;
            font-size: 0.3rem;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .loading {
            width: 100%;
            margin-bottom: 20px;
            .el-loading-mask {
              .el-loading-spinner {
                .el-icon-loading {
                  color: #ef3731;
                }
                .el-loading-text {
                  color: #ef3731;
                }
              }
            }
          }
        }
        .mobileContentRightbottom::-webkit-scrollbar {
          display: none; /* Chrome Safari */
        }
      }
    }
    .contact {
      z-index: 2001;
      bottom: 35%;
      right: 1%;
      .made,
      .mobile {
        width: 1.7rem;
        height: 1.7rem;
        padding: 0.2rem;
        margin-bottom: 0.2rem;
        img {
          width: 0.4rem;
        }
        div {
          font-size: 0.2rem;
        }
      }
    }
    .cloudright {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 1.25rem;
    }
  }
}
</style>
